import { useMatches } from 'react-router';

export const useCurrentPage = () => {
  const matches = useMatches();
  return matches[matches.length - 1];
};
